import type { AdPlacement } from '../adUnit.ts';
import type { DistributionChannel } from '../distributionChannel.ts';
import type { ConstValues } from '../helpers.ts';

import type { CriteriaValue, Intersect } from './targetingValuesTypes.ts';

export const InventoryFormatTypeOption = {
  DISTRIBUTION_CHANNEL: 'distribution_channel',
  AD_PLACEMENT: 'ad_placement',
} as const;
export type InventoryFormatTypeOption = ConstValues<typeof InventoryFormatTypeOption>;

export type FormatTypeData = {
  op: CriteriaValue;
  [InventoryFormatTypeOption.DISTRIBUTION_CHANNEL]?: {
    op: Intersect;
    val: DistributionChannel;
  } | null;
  [InventoryFormatTypeOption.AD_PLACEMENT]?: {
    op: Intersect;
    val: AdPlacement;
  } | null;
};
